import { Link } from "react-router-dom";

const CourseCard = ({
	imgSrc,
	imgAlt,
	category1,
	category2,
	title,
	description,
	tutorName,
	tutorTitle,
	discountedPrice,
	originalPrice,
	link,
	tutorImg,
}) => {
	return (
		<article className="courses__course">
			<div className="courses__img-box">
				<img src={imgSrc} alt={imgAlt} className="courses__img" />
			</div>

			<div className="courses__label-box">
				<label className="courses__label btn">{category1}</label>
				<label className="courses__label btn">{category2}</label>
			</div>

			<div className="courses__desc-box">
				<h4 className="courses__title">{title}</h4>
				<p className="courses__desc">{description}</p>
			</div>

			<div className="courses__tutor-box">
				<img
					src={tutorImg}
					alt={tutorName}
					className="courses__tutor-box__img"
				/>
				<div>
					<div className="courses__tutor-box__name">{tutorName}</div>
					<div className="courses__tutor-box__title">{tutorTitle}</div>
				</div>
			</div>

			<div className="courses__checkout-box">
				<div className="courses__price-box">
					<span className="courses__price-box__dicounted-price">
						<span>&#8377;</span>
						{discountedPrice}
					</span>
					<span className="courses__price-box__original-price">
						<s>{originalPrice}</s>
					</span>
				</div>

				<Link
					to={link}
					className="btn btn--blue courses__cta-btn btn-link link__btn"
				>
					View Details
				</Link>
			</div>
		</article>
	);
};

export default CourseCard;
